import { render, staticRenderFns } from "./PostalCodeAddressInput.vue?vue&type=template&id=0dffcca8&"
import script from "./PostalCodeAddressInput.vue?vue&type=script&lang=js&"
export * from "./PostalCodeAddressInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports